var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardsOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8049 11.1796L15.9864 12.2006C16.0353 12.4758 15.9742 12.7527 15.8142 12.9822C15.6546 13.211 15.4164 13.3629 15.1405 13.412L3.2609 15.5234L3.26082 15.5235C3.19851 15.5345 3.13604 15.54 3.07528 15.54C2.86456 15.54 2.65887 15.4761 2.48078 15.3515L2.48035 15.3512C2.25128 15.1914 2.09921 14.9535 2.05022 14.6777L2.0482 14.6663L2.04549 14.6551L1.43225 12.1192H13.8244C14.5715 12.1192 15.1457 11.9352 15.5298 11.5499C15.6424 11.4371 15.733 11.3126 15.8049 11.1796ZM13.8624 0.967163C14.4382 0.967163 14.9069 1.43591 14.9069 2.01165V9.81882C14.9069 10.3946 14.4382 10.8633 13.8624 10.8633H1.79681C1.22106 10.8633 0.752319 10.3946 0.752319 9.81882V2.01165C0.752319 1.43591 1.22107 0.967163 1.79681 0.967163H13.8624Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41399 6.167H8.80412V7.44503H2.41399V6.167Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.800293 2.75952H14.8586V5.07275H0.800293V2.75952Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardsOutline);
export default __webpack_public_path__ + "static/media/cards-outline.45a124f68e4e2c906aff684c57960508.svg";
export { ForwardRef as ReactComponent };